import { CircularProgress } from "@mui/material";
import React from "react";
import Button from "./Button";

export function SubmitButton({ onClick, disabled, isSaving }) {
  return (
    <Button
      type="primary"
      label={<>Submit {isSaving && <CircularProgress size={12} />}</>}
      size="small"
      disabled={disabled}
      loading={false}
      stretch={false}
      center={true}
      onClick={onClick}
    />
  );
}
